module.exports = __webpack_public_path__ + "static/img/__balloons.935177a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__balloons.jpg
// module id = VwmV
// module chunks = 0